import { z } from "zod";

const BrowseComplianceSummarySchema = z.object({
  query: z.any(),
});

export default BrowseComplianceSummarySchema;
